import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../components/HOC/injectRole'
import { TRoles, TRoutes } from '../../shared/const'

import TlCourses from '../../components/views/common/TlCourses'
import TlCoursePlayer from '../../components/views/common/TlCourses/TlCoursePlayer'

/*
 * Kurse von TalentsLounge (Menüpunkt „Kurse"). Schüler:innen lernen,
 * Lehrkräfte sehen den Stand ihrer Junior Companies und die Angebote von
 * TalentsLounge, die Verwaltung schaut zu. Den Kurs selbst öffnen nur
 * Schüler:innen — der Server gibt anderen keinen Startschlüssel.
 */
const DARF = [TRoles.STUDENT, TRoles.TEACHER, TRoles.ADMIN, TRoles.FEDERAL_ADMIN]

function Uebersicht(props) {
	if (!DARF.includes(props.role)) return <Redirect to={TRoutes.DASHBOARD} />
	return <TlCourses role={props.role} />
}

Uebersicht.propTypes = { role: PropTypes.string.isRequired }

function Kurs(props) {
	if (props.role !== TRoles.STUDENT) return <Redirect to={TRoutes.TL_COURSES} />
	return <TlCoursePlayer />
}

Kurs.propTypes = { role: PropTypes.string.isRequired }

export const TlCoursesPage = injectRole(Uebersicht)
export const TlCoursePage = injectRole(Kurs)
